"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.decode = decode;
exports.update = update;
exports.encode = encode;

var _querystring = require('querystring');

var querystring = _interopRequireWildcard(_querystring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function decode(urlOrQs) {
    var qs = urlOrQs;
    var i = qs.indexOf('?');
    if (i >= 0) {
        qs = qs.substr(i + 1);
    }
    return querystring.decode(qs);
}

function getParts(url) {
    var parts = {};
    if (typeof url === 'string') {
        parts.path = url;

        var qIndex = url.indexOf('?');
        var hIndex = url.indexOf('#');
        if (qIndex >= 0 || hIndex >= 0) {
            var pEndIndex = qIndex >= 0 ? qIndex : hIndex;
            parts.path = url.substr(0, pEndIndex);
            if (qIndex >= 0) {
                var qEndIndex = (hIndex >= 0 ? hIndex - 1 : url.length) - qIndex;
                parts.query = url.substr(qIndex + 1, qEndIndex);
            }
            if (hIndex >= 0) {
                parts.hash = url.substr(hIndex + 1);
            }
        }
    }
    return parts;
}

function joinParts(parts) {
    var url = parts.path || '';
    if (typeof parts.query === 'string' && parts.query.length > 0) {
        url += '?' + parts.query;
    }
    if (typeof parts.hash === 'string' && parts.hash.length > 0) {
        url += '#' + parts.hash;
    }
    return url;
}

function update(url, cb) {
    if (typeof cb !== 'function') return;
    var parts = getParts(url);
    var qs = decode(parts.query || '');
    var ret = cb(qs);
    if ((typeof ret === 'undefined' ? 'undefined' : _typeof(ret)) === 'object') {
        qs = ret;
    }
    parts.query = encode(qs);
    return joinParts(parts);
}

function encode() {
    return querystring.encode.apply(this, arguments);
}

exports.default = {
    decode: decode,
    parse: decode,

    encode: encode,
    stringify: encode,

    update: update
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/querystring.js
// module id = 105
// module chunks = 0 1